'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'file-spreadsheet';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f65b';
var svgPathData = 'M64 32l128 0 0 96c0 35.3 28.7 64 64 64l96 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 45.3L338.7 160 256 160c-17.7 0-32-14.3-32-32l0-82.7zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-261.5c0-17-6.7-33.3-18.7-45.3L242.7 18.7C230.7 6.7 214.5 0 197.5 0L64 0zM96 256c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 256zm80 32l0 48-80 0 0-48 80 0zm0 80l0 48-80 0 0-48 80 0zm32 48l0-48 80 0 0 48-80 0zm0-80l0-48 80 0 0 48-80 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileSpreadsheet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;